const About = () => import("../views/about/about.vue")

export default [
    {
        path: '/about',
        name: 'about',
        component: About,
        meta: {
            keepAlive: true
        }
    }
]